module.exports = __webpack_public_path__ + "static/media/Olivia Main Wardrobe (6).67ea0b76.jpg";